import { render, staticRenderFns } from "./TransferAccountRangeDetail.vue?vue&type=template&id=bae714da&"
import script from "./TransferAccountRangeDetail.vue?vue&type=script&lang=js&"
export * from "./TransferAccountRangeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports